import Vue from 'vue'
import Vuex from "vuex";

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        jiraUrl: "",
        askNotCommitedLogs: true,
        topicSuggestionHistoryLength: 30,
        fixedStartOfWork: false,
        startOfWorkTime: null,
        googleApi: {
            clientId: null,
            driveApiKey: null,
            enableAutoBackup: false
        }
    },
    mutations: {
        initialiseStore(state) {
            if(localStorage.getItem('settings')) {
                this.replaceState(
                    Object.assign(state, JSON.parse(localStorage.getItem('settings')))
                );
            }
        },
        setJiraUrl(state, jiraUrl) {
            state.jiraUrl = jiraUrl
        },
        setAskNotCommitedLogs(state, askNotCommitedLogs) {
            state.askNotCommitedLogs = askNotCommitedLogs
        },
        setTopicSuggestionHistoryLength(state, topicSuggestionHistoryLength) {
            state.topicSuggestionHistoryLength = topicSuggestionHistoryLength
        },
        setFixedStartOfWork(state, fixedStartOfWork) {
            state.fixedStartOfWork = fixedStartOfWork;
        },
        setStartOfWorkTime(state, startOfWorkTime) {
            state.startOfWorkTime = startOfWorkTime;
        },
        setGoogleClientId(state, googleClientId) {
            if (!state.googleApi) {
                state.googleApi = {};
            }
            state.googleApi.clientId = googleClientId;
        },
        setGoogleDriveApiKey(state, googleDriveApiKey) {
            if (!state.googleApi) {
                state.googleApi = {};
            }
            state.googleApi.driveApiKey = googleDriveApiKey;
        },
        setEnableAutoBackup(state, enableAutoBackup) {
            if (!state.googleApi) {
                state.googleApi = {};
            }
            state.googleApi.enableAutoBackup = enableAutoBackup;
        }
    },
    getters: {
        jiraUrl: state => state.jiraUrl,
        askNotCommitedLogs: state => state.askNotCommitedLogs,
        topicSuggestionHistoryLength: state => state.topicSuggestionHistoryLength,
        fixedStartOfWork: state => state.fixedStartOfWork,
        startOfWorkTime: state => state.startOfWorkTime,
        googleClientId: state => state.googleApi ? state.googleApi.clientId : null,
        googleDriveApiKey: state => state.googleApi ? state.googleApi.driveApiKey : null,
        enableAutoBackup: state => state.googleApi ? state.googleApi.enableAutoBackup : null,
    }
});

store.subscribe((mutation, state) => {
    // Store the state object as a JSON string
    localStorage.setItem('settings', JSON.stringify(state));
});
